<template>
  <v-card
    elevation="0"
    class="mainShareCard">
    <v-tabs grow v-model="tab">
      <v-tab :disabled="type === 'Bulbs' || (bulb_data.lmb_id === 1) || selectedData.length > 0">
        Preview Link
      </v-tab>
      <v-tab
      :disabled="disableCoOwnerTab"
      >
        Manage Permissions
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item :key="0">
        <div class="tab-item-container">
          <div class="class-info-container">
            <div class="preview-info">
              <span>Preview links can not be assigned to learners. No data collected or saved.</span>
            </div>
          </div>
          <div class="copy-container">
            <v-text-field
              box
              hide-details
              readonly
              :value="publicUrl">
            </v-text-field>
            <ClipboardCopy :copyText="publicUrl"></ClipboardCopy>
          </div>
          <div class="advanced-container">
            <a
              class="link-button"
              @click="advancedShow = !advancedShow"
              tabindex=0
              >
              Advanced settings
            </a>
            <div
              v-show="advancedShow"
              style="padding-left:16px;">
              <v-switch
                v-if="hasSamlLogin"
                v-model="samlLogin"
                label="Require SAML Login"
                height="30"></v-switch>
              <div class="advanced-section">
                <v-switch
                  v-model="share.embed"
                  label="Show Embed Code"
                  height="30">
                </v-switch>
                <v-checkbox
                  v-model="share.smaller"
                  label="Smaller embed"
                  :disabled="!share.embed"
                  height="30">
                </v-checkbox>
              </div>
            </div>
          </div>
        </div>
      </v-tab-item>
      <v-tab-item :key="1">
        <BulbCollaborate
          :bulb_data="bulb_data">
        </BulbCollaborate>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
'use strict';
import {
  mapState,
  mapGetters,
} from 'vuex';
// Validations from Vuelidate
import { validationMixin } from 'vuelidate';
import ClipboardCopy from '@/components/buttons/clipboardCopy';
import BulbCollaborate from '@/components/modal-views/BulbCollaborate.vue';
import _ from 'lodash';

export default {
  name: 'share',
  components: {
    BulbCollaborate,
    ClipboardCopy,
  },
  mixins: [validationMixin],
  props: [
    'bulb_data',
    'class_data',
    'instructor_id',
    'hotlink',
    'classes',
    'lti',
    'type',
    'school_id'
  ],
  data() {
    return {
      tab: 0,
      advancedShow: false,
      share: {
        embed: false,
        graded: false,
        colleague: false,
        authenticate: false,
        join: false,
        name: false,
        smaller: false
      },
      samlLogin: false,
    };
  },
  computed: {
    ...mapState('instructors', [
      'selectedUser',
    ]),
    ...mapGetters([
      'instructorData',
      'phpApiPrefix',
      'school',
      'shareNodeApiPrefix',
    ]),
    ...mapGetters('instructors', [
      'hasSamlLogin',
      'selectedData',
    ]),
    disableCoOwnerTab() {
      // If schoolId is null - disable CoOwners tab
      if (!this.school_id) return true;
      // If there is a school id show CoOwners tab
      return false;
    },
  //computed for sharing bulbs
    shareBulbName: function(){
      //replace spaces with dashes
      return this.bulb_data.name.replace(/\s/g, '-').replace(/\//g, '-').replace(/[^a-zA-Z0-9-]/g, '');
    },
    publicUrl: function(){
      let section;
      if (Object.keys(this.class_data).length > 0){
        section = this.class_data.id;
      } else section = 0;
      let url = `${this.shareNodeApiPrefix}/go/share/${this.bulb_data.id}/${this.instructor_id}/${section}/0/${this.shareBulbName}`;
      if (this.samlLogin) url = `${this.phpApiPrefix}/saml/${this.school.id}?redirect=/r/share/${this.bulb_data.id}/${this.instructor_id}/${section}`;

      if(this.share.embed){
        if(this.share.smaller){
          return `<iframe width="635" height="520" scrolling="no" src="${url}" allow="autoplay *;" allowfullscreen frameborder="0"></iframe>`
        } else {
          return `<iframe width="768" height="597" scrolling="no" src="${url}" allow="autoplay *;" allowfullscreen frameborder="0"></iframe>`
        }
      } else {
        return url;
      }
    },
  },
  methods: {
    setTab: function(){
      if (this.selectedData.length > 0 || this.type === 'Bulbs') this.tab = 1;
      else this.tab = 0;
    },
  },
  watch:{
    tab: {
      handler: function(val, oldVal){
        if(val != oldVal){
          this.share = {
            embed: false,
            graded: false,
            colleague: false,
            authenticate: false,
            join: false,
            name: false,
            smaller: false
          }
          this.advancedShow = false;
        }
      }
    },
  },
  mounted() {
    this.setTab();
    this.samlLogin = _.get(this.school, 'config.enableSamlByDefault', false);
  },
};
</script>

<style>
.tab-item-container{
  background-color: #fff;
}

.icon-div {
  margin: 0px 8px 0px 8px;
}

.ownerList {
  overflow: initial !important;
}

.preview-info{
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;
  padding: 5px 24px 0px 24px;
}

.preview-info span {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.64);
}

.copy-button {
  font-size: 15px !important;
}

.copy-container{
  width: 100%;
  height: 60px;
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 24px;
}

.advanced-copy{
  padding: 0px 0px !important;
}

.copy-container .v-input {
  flex: none;
}

.copy-container .v-input, .copy-container .v-input__control, .copy-container .v-input__slot {
  width: 600px !important;
  height: 40px !important;
  min-height: 40px !important;
}

.copy-container .v-input_control:before , .copy-container .v-input__slot:before {
  border: none !important;
}

.copy-container input {
  margin-top: 6px;
  outline: none!important;
}

.link-button {
  color: rgba(0, 0, 0, 0.64);
  font-weight: bolder;
  font-size: 15px !important;
}

.advanced-container {
  padding: 24px 24px 16px 24px;
}

.advanced-container .v-label {
  font-size: 14px !important;
}

.advanced-section {
  height: 50px;
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: flex-start;
}

.no-class-container{
  width: 100%;
  height: 100px;
  display: flex;
  flex-flow: row;
  justify-content: space-around;
  align-items: center;
  padding: 0px 36px;
}

.notOwner {
  background: white;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.64);
}

.padding-left {
  padding-left: 18px;
}

.copy-confirm {
  width: 88px;
  height: 28px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  background-color: #4CAE51;
}

.copy-confirm span {
  color: white;
}

.actionSelect {
  max-width: 55% !important;
}

.ownerCard {
  max-height: 350px;
  overflow-y: auto;
}

.emailInput {
  width:100%;
}

.mainShareCard {
  min-height: 300px;
  background-color: #fff;
  overflow: auto;
}

</style>
